/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/greenmist.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const ACCENT_COLOR = "#3cbab2";
const BACKGROUND_COLOR = "#f5f5f5";
const TITLE_COLOR = "#28484f";
const SUBTITLE_COLOR = "#7eb2be";
const TEXT_COLOR = "#657c80";
const BORDER_COLOR = "#dedede";
export default [{
    baseThemeName: "generic.light",
    theme: {
        name: "generic.greenmist",
        defaultPalette: "Green Mist",
        backgroundColor: "#f5f5f5",
        primaryTitleColor: "#28484f",
        secondaryTitleColor: "#7eb2be",
        gridColor: "#dedede",
        axisColor: "#657c80",
        export: {
            backgroundColor: "#f5f5f5",
            font: {
                color: "#28484f"
            },
            button: {
                default: {
                    color: "#28484f",
                    borderColor: "#a2b4b8",
                    backgroundColor: "#f5f5f5"
                },
                hover: {
                    color: "#28484f",
                    borderColor: "#7f989e",
                    backgroundColor: "rgba(222, 222, 222, 0.4)"
                },
                focus: {
                    color: "#28484f",
                    borderColor: "#5f777c",
                    backgroundColor: "rgba(222, 222, 222, 0.4)"
                },
                active: {
                    color: "#28484f",
                    borderColor: "#5f777c",
                    backgroundColor: "rgba(222, 222, 222, 0.8)"
                }
            }
        },
        legend: {
            font: {
                color: "#657c80"
            }
        },
        tooltip: {
            color: "#fff",
            border: {
                color: "#dedede"
            },
            font: {
                color: "#28484f"
            }
        },
        "chart:common": {
            commonSeriesSettings: {
                label: {
                    border: {
                        color: "#dedede"
                    }
                }
            }
        },
        "chart:common:annotation": {
            color: "#fff",
            border: {
                color: "#dedede"
            },
            font: {
                color: "#28484f"
            }
        },
        chart: {
            commonPaneSettings: {
                border: {
                    color: "#dedede"
                }
            },
            commonAxisSettings: {
                breakStyle: {
                    color: "#c1c1c1"
                }
            }
        },
        funnel: {
            item: {
                border: {
                    color: "#f5f5f5"
                }
            }
        },
        sparkline: {
            pointColor: "#f5f5f5",
            minColor: "#ffc852",
            maxColor: "#f74a5e"
        },
        treeMap: {
            group: {
                color: "#dedede",
                label: {
                    font: {
                        color: "#7eb2be"
                    }
                }
            }
        },
        rangeSelector: {
            shutter: {
                color: "#f5f5f5"
            },
            scale: {
                breakStyle: {
                    color: "#c1c1c1"
                },
                tick: {
                    opacity: .12
                }
            },
            selectedRangeColor: "#3cbab2",
            sliderMarker: {
                color: "#3cbab2"
            },
            sliderHandle: {
                color: "#3cbab2",
                opacity: .5
            }
        },
        bullet: {
            color: "#3cbab2"
        },
        gauge: {
            valueIndicators: {
                rangebar: {
                    color: "#3cbab2"
                },
                textcloud: {
                    color: "#3cbab2"
                }
            }
        }
    }
}, {
    baseThemeName: "generic.greenmist",
    theme: {
        name: "generic.greenmist.compact"
    }
}];
